import { getCookie, setCookie } from '@/utils/cookie';

export const saveTokens = ({
  accessToken,
  refreshToken,
  accessExpiredTime,
  refreshExpiredTime,
}: AuthData) => {
  if (accessExpiredTime && refreshExpiredTime) {
    // 세션 토큰으로 사용; 로그아웃 순간까지 인증 토큰이 필요하기 때문에 만료 속성은 지정하지 않는다.
    setCookie('accessToken', accessToken, {
      sameSite: 'strict',
      path: '/',
    });
    // 세션 토큰으로 사용; 로그아웃 순간까지 인증 토큰이 필요하기 때문에 만료 속성은 지정하지 않는다.
    setCookie('refreshToken', refreshToken, {
      sameSite: 'strict',
      path: '/',
    });
  }
};

export const getTokens = (): {
  accessToken: string;
  refreshToken: string;
} | null => {
  const accessToken = (getCookie('accessToken') as string) || null;
  const refreshToken = (getCookie('refreshToken') as string) || null;
  // All Or Nothing
  if (accessToken && refreshToken) {
    return { accessToken, refreshToken };
  }
  return null;
};

export const authErrorHandler = (errors) => {
  let message = '';

  for (const { code } of errors) {
    switch (code) {
      case 'ERR_0111': // 리프레시 토 큰이 만료된 경우
        message = '오랫동안 접속하지 않아 로그아웃되었습니다.';
        break;
      case 'ERR_0102': // 리프레시토큰이 DB에 존재하지 않을 경우
      case 'ERR_0104': // ACCESS_TOKEN 헤더가 존재하지 않는 경우
      case 'ERR_0106': // 유효하지 않는 토큰인 경우
      case 'ERR_0109': // 토큰 타입이 잘못된 경우
      case 'ERR_0110':
        message = '서버에서 발급된 토큰이 아니거나 유효하지 않는 토큰입니다.';
        break;
      default:
        break;
    }
  }

  return message;
};
